import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Logout = props => {
  return (
    <SvgIcon {...props}>
      <path d="M19 3H5C3.89 3 3 3.89 3 5V9H5V5H19V19H5V15H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3ZM10.08 15.58L11.5 17L16.5 12L11.5 7L10.08 8.41L12.67 11H3V13H12.67L10.08 15.58Z" />
    </SvgIcon>
  );
};

export default SvgI24Logout;
